export const SVG_NS = "http://www.w3.org/2000/svg";
export const FONT_STACK = 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
export function setAttrs(element, attrs) {
    for (const [name, value] of Object.entries(attrs)) {
        if (value === undefined || value === null || value === false) {
            element.removeAttribute(name);
            continue;
        }
        element.setAttribute(name, value === true ? "true" : String(value));
    }
}
export function svgEl(tag, attrs = {}, parent) {
    const element = document.createElementNS(SVG_NS, tag);
    setAttrs(element, attrs);
    if (parent)
        parent.appendChild(element);
    return element;
}
export function textEl(parent, x, y, content, attrs = {}) {
    const element = svgEl("text", { x, y, ...attrs }, parent);
    element.textContent = content;
    return element;
}
export function truncate(value, max) {
    if (value.length <= max)
        return value;
    return `${value.slice(0, Math.max(0, max - 1))}…`;
}
export function escapeHtml(value) {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}
